import {
    MarkdownConverter,
    PoolCard,
    PoolCardContent,
    PoolCardHeader,
    PoolFormattedRelativeTime,
    PoolImage,
    PoolLineClampTypography,
    PoolTypography,
} from '@synergy/components-next';
import { ReactElement } from 'react';
import { Stack, styled } from '@mui/material';

import { NewsPost } from '../../models/news-post';

const StyledPoolCard = styled(PoolCard)(({ theme }) => ({
    height: 418,
    minWidth: 287,
    width: 489,

    [theme.breakpoints.down('sm')]: {
        width: 287,
    },
}));

const StyledPoolCardHeader = styled(PoolCardHeader)(() => ({
    height: 274,
    padding: 0,
}));

const StyledImage = styled(PoolImage)(() => ({
    width: '100%',
    height: '100%',
    objectFit: 'contain',
}));

export interface NewsCardProps {
    news: NewsPost;
    onClick?: (newsId: number) => void;
    href?: string;
}

/**
 * NewsCard<br>
 * <a href="https://www.figma.com/file/kjfAT06qgLdW52cF1SqWuy/Pool-Alpin-%E2%80%93-Shop-Library?node-id=3%3A15654" target="_blank">Open in Figma</a>
 */
export const NewsCard = (props: NewsCardProps): ReactElement => {
    const { news, href } = props;

    return (
        <StyledPoolCard href={href}>
            <StyledPoolCardHeader>
                <StyledImage src={news.thumbnailUrl} alt={news.title} />
            </StyledPoolCardHeader>

            <PoolCardContent sx={{ pt: 3, pb: 3 }}>
                <Stack gap={0.5} sx={{ height: '100%' }}>
                    <PoolLineClampTypography maxLines={1} variant="subtitle1" component="span">
                        {news.title}
                    </PoolLineClampTypography>
                    <PoolLineClampTypography maxLines={2} variant="body1" sx={{ flex: 1 }}>
                        <MarkdownConverter value={news.text} />
                    </PoolLineClampTypography>
                    <PoolTypography variant="body1" color="grey.800">
                        <PoolFormattedRelativeTime value={news.publishAt} />
                    </PoolTypography>
                </Stack>
            </PoolCardContent>
        </StyledPoolCard>
    );
};
